/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setScrollTrigger.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * __00: 初期設定
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

/**
 * 一括処理
 */
const setScrollTrigger = () => {
  setAboutScrollTrigger();
  setBusinessScrollTrigger();
  setPointScrollTrigger();
  setCrewScrollTrigger01();
  setCrewScrollTrigger02();
  setNewsScrollTrigger();
  setInitScrollTrigger();
};

/**
 * 初期値
 */
let easingTime = window.matchMedia("(min-width: 835px)").matches ? 1.2 : 0.8;
let pinOptions = { scrub: 1, pin: true, anticipatePin: 1, invalidateOnRefresh: true, }
let actionOptions = { duration: easingTime, ease: 'power4.outPower4.out', overwrite: true, stagger: { amount: 0.2, from: "start", }, }
let resizeWindowWidth = window.innerWidth;
let resizeWindowHeight = window.innerHeight;
let startPos = (resizeWindowWidth / (1440 / 192)) / 2;
let setWidth = (resizeWindowWidth / (1440 / 1110));
let triggerOptions = { start: `${startPos} 65%`, end: `${startPos} 65%`, once: false }

//リサイズイベント
let timer = false;
function resizeEvent() {
  let resize_width = window.innerWidth;
  if (resizeWindowWidth != resize_width) {
    timer !== false && clearTimeout(timer);
    timer = setTimeout(function () {
      resizeWindowWidth = window.innerWidth;
      resizeWindowHeight = window.innerHeight;
      startPos = (resizeWindowWidth / (1440 / 192)) / 2;
      setWidth = (resizeWindowWidth / (1440 / 1110));
      resizeWindowWidth = resize_width;
    }, 100);
  }
}
window.addEventListener("orientationchange", resizeEvent);
window.addEventListener("resize", resizeEvent);

/**
 * 処理
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * __10:共通 - 指定クラスが特定の位置に来たらアニメーション実行処理
 * @param {string} getTrigger - スクロールトリガーとなる要素
 * @param {string} target__el - スクロール対象となる要素
 */
function setInitScrollTrigger() {
  let setTrigger = document.querySelectorAll('.--js_setTrigger');

  setTrigger.forEach((getTrigger) => {
    let h2_en = getTrigger.querySelectorAll("h2.en > span");
    let text_line = getTrigger.querySelectorAll(".line-wrap .line");

    gsap.set([h2_en], { y: 30, });
    text_line.forEach((el) => gsap.set(el, { y: el.clientHeight, }));

    ScrollTrigger.batch(getTrigger, {
      onEnter: () => {
        gsap.to([h2_en], { ...actionOptions, y: 0, });
        gsap.to([text_line], { ...actionOptions, y: 0, });
      },
      ...triggerOptions,
      // markers: true,
    });
  });
}

/**
 * __20:共通 - スクロール量に応じて横スクロール
 * @param {string} getTrigger - スクロールトリガーとなる要素
 * @param {string} scrollbar - スクロールバー
 * @param {string} target__el - スクロール対象となる要素
 * 
 */
const scrollSlide_X = (getTrigger, scrollbar) => {
  //スクロールに応じて横スクロール
  getTrigger.querySelectorAll(".--js_slideTarget-el").forEach((target__el) => {
    let slideItemLength = target__el.querySelectorAll("li").length;
    let scrollSlideTriggerTimeline = gsap.timeline({ ease: "none", scrollTrigger: { trigger: getTrigger, start: () => `top top`, end: () => `+=${target__el.clientWidth - setWidth}`, ...pinOptions } });

    scrollSlideTriggerTimeline
      .to(target__el, { x: () => `-${target__el.clientWidth - setWidth}`, overwrite: true }, 0)
      .to(scrollbar, { x: () => `${scrollbar.clientWidth * (slideItemLength - 1) + 2}`, overwrite: true }, 0);
  })
}

/**
 * __30:コンテンツ - about
 * @param {string} getTrigger - スクロールトリガーとなる要素
 */
function setAboutScrollTrigger() {
  let setTrigger = document.querySelectorAll('.--js_setTrigger.--about');

  //スクロールアニメーション
  setTrigger.forEach((getTrigger) => {
    let h3_jp = getTrigger.querySelectorAll("h3 > .--create_span:not(.en) > span");
    let h3_en = getTrigger.querySelectorAll("h3 > .en > span");

    gsap.set([h3_jp], { y: 70, });
    gsap.set([h3_en], { y: 60, });

    ScrollTrigger.batch(getTrigger, {
      onEnter: () => {
        gsap.to([h3_jp], { ...actionOptions, y: 0, });
        gsap.to([h3_en], { ...actionOptions, y: 0, });
      },
      ...triggerOptions,
      // markers: true,
    });
  });
}

/**
 * __40:コンテンツ - Our business
 * @param {string} getTrigger - スクロールトリガーとなる要素
 * @param {string} target__el - スクロール対象となる要素
 */
function setBusinessScrollTrigger() {
  let setTrigger = document.querySelectorAll('.--js_setTrigger.--business');
  let fixStartPos = document.querySelector('.--js_fixStart');
  let fixEndPos = document.querySelector('.--js_fixEnd');
  let fixItem = document.querySelectorAll('.--js_fixItem');
  let fixState = document.querySelectorAll('.--js_fixState');
  let getStartHeight = 0, getEndHeight = 0;

  //初期処理
  let init = () => {
    getStartHeight = fixStartPos.clientHeight;
    getEndHeight = 400 - fixEndPos.clientHeight;
    fixItem.forEach((item) => {
      item.parentElement.style.height = `${getStartHeight}px`;
      item.parentElement.style.setProperty('--minH', `${getEndHeight / 2}px`);
    });
  }

  const fixItemAnimation = () => {
    let fixCurrent = document.querySelectorAll(".num.--current .data");
    let fixItemImg = document.querySelectorAll('.--js_fixItem .img');
    let fixTriggerOptions = { start: `50% 50%`, end: `50% 50%`, once: false }
    let fixCurrentOptions = { duration: 0.3, ease: 'ease', overwrite: true }

    //固定開始位置
    ScrollTrigger.batch(fixStartPos, {
      onEnter: () => fixItem.forEach((item) => item.classList.add("--is_fixed")),
      onEnterBack: () => fixItem.forEach((item) => item.classList.remove("--is_fixed")),
      ...fixTriggerOptions,
    });

    //固定終了位置
    ScrollTrigger.batch(fixEndPos, {
      onEnter: () => {
        fixItem.forEach((item) => item.classList.remove("--is_fixed"))
        fixState.forEach((item) => item.classList.add("--is_end"))
      },
      onEnterBack: () => {
        fixItem.forEach((item) => item.classList.add("--is_fixed"))
        fixState.forEach((item) => item.classList.remove("--is_end"))
      },
      ...fixTriggerOptions,
    });

    //スクロールアニメーション
    setTrigger.forEach((getTrigger) => {
      getTrigger.querySelectorAll(".--js_businessListTarget").forEach((target__el, index) => {
        ScrollTrigger.batch(target__el, {
          onEnter: () => {
            fixItemImg[index].classList.add("--is_active");
            gsap.to(fixCurrent[index + 1], { ...fixCurrentOptions, overwrite: false, translateY: `0`, });
            if (index !== 0) {
              fixItemImg[index - 1].classList.remove("--is_active");
              gsap.to(fixCurrent[index], { ...fixCurrentOptions, translateY: `-1.2em`, }, "<");
            }
            if (index === 9) {
              gsap.to(fixCurrent[0], { ...fixCurrentOptions, translateY: `-1.2em`, }, "<");
              gsap.to(fixCurrent[11], { ...fixCurrentOptions, translateY: `0`, }, "<");
            }
          },
          onEnterBack: () => {
            if (index !== 0) {
              fixItemImg[index - 1].classList.add("--is_active");
              fixItemImg[index].classList.remove("--is_active");
              gsap.to(fixCurrent[index], { ...fixCurrentOptions, translateY: `0`, });
              gsap.to(fixCurrent[index + 1], { ...fixCurrentOptions, translateY: `1.2em`, }, "<");
            }
            if (index === 9) {
              gsap.to(fixCurrent[0], { ...fixCurrentOptions, translateY: `0`, }, "<");
              gsap.to(fixCurrent[11], { ...fixCurrentOptions, translateY: `1.2em`, }, "<");
            }
          },
          start: `-50% 50%`,
          end: `-50% 50%`,
          once: false,
          // markers: true,
        });
      });
    });
  }

  //スクロールアニメーション
  setTrigger.forEach((getTrigger) => {
    let h3_main = getTrigger.querySelectorAll("h3 > .main");
    let h3_sub = getTrigger.querySelectorAll("h3 > .sub");
    let fixItemImg = getTrigger.querySelectorAll(".img img");
    let current_num = getTrigger.querySelectorAll(".num.--current");
    let current_line = getTrigger.querySelectorAll(".num.--line");
    let current_all = getTrigger.querySelectorAll(".num.--all");
    let addEasingTime = window.matchMedia("(min-width: 835px)").matches ? 1.4 : 1;

    gsap.set([h3_main], { y: 40, backgroundSize: "100% 500%", opacity: 0 })
    gsap.set([h3_sub], { y: 40, opacity: 0 });
    gsap.set([fixItemImg], { scale: 0.5, opacity: 0 });
    gsap.set([current_num], { y: 40, opacity: 0 });
    gsap.set([current_line], { scaleX: 0 });
    gsap.set([current_all], { y: 40, opacity: 0 });

    ScrollTrigger.batch(getTrigger, {
      onEnter: () => {
        gsap.to([h3_main], { ...actionOptions, y: 0, backgroundSize: "100% 100%", opacity: 1, });
        gsap.to([h3_sub], { ...actionOptions, y: 0, opacity: 1, });
        gsap.to([current_num], { ...actionOptions, y: 0, opacity: 1, });
        gsap.to([current_line], { ...actionOptions, scaleX: 1, });
        gsap.to([current_all], { ...actionOptions, y: 0, opacity: 1, });
        gsap.to([fixItemImg], { ...actionOptions, opacity: 1, });
        gsap.to([fixItemImg], { duration: addEasingTime, ease: "back.out(1.2)", scale: 1, }, "<");
      },
      ...triggerOptions,
      // markers: true,
    });
  });

  init();
  window.addEventListener("resize", init);
  fixItemAnimation();
}

/**
 * __50:コンテンツ - We have
 * @param {string} getTrigger - スクロールトリガーとなる要素
 */
function setPointScrollTrigger() {
  let setTrigger = document.querySelectorAll('.--js_setTrigger.--point');

  //スクロールアニメーション
  setTrigger.forEach((getTrigger) => {
    let h3_jp = getTrigger.querySelectorAll("h3 > .--create_span:not(.en) > span");
    let h3_en = getTrigger.querySelectorAll("h3 > .en > span");
    let pointItemImg = getTrigger.querySelectorAll(".point__list-item img");

    gsap.set([h3_jp], { y: 70, });
    gsap.set([h3_en], { y: 60, });
    gsap.set([pointItemImg], { scale: 1.2, opacity: 0 });

    ScrollTrigger.batch(getTrigger, {
      onEnter: () => {
        gsap.to([h3_jp], { ...actionOptions, y: 0, });
        gsap.to([h3_en], { ...actionOptions, y: 0, });
        gsap.to([pointItemImg], { ...actionOptions, scale: 1, opacity: 1, });
      },
      ...triggerOptions,
      // markers: true,
    });
  });
}

/**
 * __60:コンテンツ - crew - 01
 * @param {string} getTrigger - スクロールトリガーとなる要素
 * @param {string} target__el - スクロール対象となる要素
 */
function setCrewScrollTrigger01() {
  let setTrigger = document.querySelectorAll(".--js_crewTrigger");
  let __crewmap = document.querySelector(".--crewmap");
  let __crewmap__cW = __crewmap?.clientWidth;
  let __crewmap__cH = __crewmap?.clientHeight;
  let __crew = document.querySelector(".--js_crew");
  let __crew_cW = __crew?.clientWidth;
  let __map = document.querySelector(".--js_map");

  setTrigger.forEach((getTrigger) => {
    let __scrollbar = getTrigger.querySelector(".--js_scrollbar");

    //crewmap → crewに切り替え
    getTrigger.querySelectorAll(".--js_crewmapTarget").forEach((target__el) => {
      let crewScrollTriggerTimeline = gsap.timeline({ ease: "none", scrollTrigger: { trigger: target__el, start: () => `top top`, end: () => `+=${resizeWindowHeight * 2}`, ...pinOptions } });

      gsap.set([__crew, __map], {
        y: () => window.matchMedia("(min-width: 835px)").matches && `${resizeWindowHeight / 2 - __crewmap__cH / 2}px`,
      },)
      crewScrollTriggerTimeline
        .to(__map, { autoAlpha: 0, }, 0)
        .to(__crew, { x: () => `${__crewmap__cW / 2 - __crew_cW / 2}`, }, 1)
    })

    //スクロールに応じて横スクロール
    window.matchMedia("(min-width: 835px)").matches && scrollSlide_X(getTrigger, __scrollbar);
  });
}

/**
 * __70:コンテンツ - crew - 02
 * @param {string} getTrigger - スクロールトリガーとなる要素
 */
function setCrewScrollTrigger02() {
  let setTrigger = document.querySelectorAll('.--crew .--js_setTrigger');

  //スクロールアニメーション
  setTrigger.forEach((getTrigger) => {
    let __scrollTrack = getTrigger.querySelector(".scroll__track");
    let __crewItem = getTrigger.querySelectorAll(".crew__list-item");

    gsap.set([__scrollTrack], { scaleX: 0, });
    gsap.set([__crewItem], {
      x: () => window.matchMedia("(min-width: 835px)").matches ? 250 : 0,
      opacity: 0,
    });

    ScrollTrigger.batch(getTrigger, {
      onEnter: () => {
        gsap.to([__scrollTrack], { ...actionOptions, scaleX: 1, });
        gsap.to([__crewItem], { ...actionOptions, x: 0, opacity: 1, });
      },
      ...triggerOptions,
      // markers: true,
    });
  });
}

/**
 * __80:コンテンツ - News
 * @param {string} getTrigger - スクロールトリガーとなる要素
 */
function setNewsScrollTrigger() {
  let setTrigger = document.querySelectorAll('.--js_setTrigger.--news');

  //スクロールアニメーション
  setTrigger.forEach((getTrigger) => {
    let content = getTrigger.querySelectorAll(".content");

    gsap.set([content], { opacity: 0, });

    ScrollTrigger.batch(getTrigger, {
      onEnter: () => {
        gsap.to([content], { ...actionOptions, opacity: 1, });
      },
      ...triggerOptions,
      // markers: true,
    });
  });
}


/**
 * 書き出し
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export {
  setScrollTrigger
};